import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class NavegadorService {
  userAgent = navigator.userAgent.toLowerCase();
  isDesktop = this.device.isDesktop();

  constructor(private device: DeviceDetectorService) {}

  private get browser(): string {
    return this.device.browser();
  }

  redirecionarParaChromeSeNecessario() {
    this.destop();
    this.mobile();
  }

  destop() {
    if (
      this.browser !== 'Chrome' &&
      this.browser !== 'Firefox' &&
      this.browser !== 'MS-Edge-Chromium' &&
      this.isDesktop
    ) {
      Swal.fire({
        title: 'Navegador não suportado!',
        text: `O navegador ${this.browser} não está suportado. Por favor, utilize o Google Chrome, Firefox ou Microsoft Edge para navegar no GEP`,
        icon: 'info',
        confirmButtonText: 'Confirmar',
        allowEscapeKey: false,
        allowOutsideClick: false,
      }).then((res) => {
        if (res.isConfirmed) {
          this.abrirNoChromeDesktop();
        }
      });
    }
  }

  mobile() {
    if (this.userAgent.includes('miuibrowser')) {
      Swal.fire({
        title: 'Navegador não suportado, utilize o Google Chrome',
        icon: 'info',
        showCancelButton: false,
        confirmButtonText: 'Confirmar',
        allowEscapeKey: false,
        allowOutsideClick: false,
      }).then((res) => {
        if (res.isConfirmed) {
          this.abrirNoChrome();
        }
      });
    }
  }

  abrirNoChrome() {
    // Redirecionar para a página do Chrome na loja de aplicativos do dispositivo
    window.location.href =
      'https://play.google.com/store/apps/details?id=com.android.chrome';
  }

  abrirNoChromeDesktop() {
    // Redirecionar para a página do Chrome na loja de aplicativos do dispositivo
    window.location.href = 'googlechrome://www.google.com';
  }
}
